import { AiOutlineDownload } from "@react-icons/all-files/ai/AiOutlineDownload";
import { GrDocumentUpload } from "@react-icons/all-files/gr/GrDocumentUpload";
import React, { createContext, useEffect, useRef, useState } from 'react';
import { Button, Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as XLSX from "xlsx-js-style";
import ExcelJS from "exceljs";
import { getAllAgentAction } from "../../Redux/Action/AgentAction";
import Auth from "../../Utilities/Auth";
import CommonModal from "../CommonComponent/CommonModal/CommonModal";
import CommonSearch from "../CommonComponent/CommonSearch/CommonSearch";
import ComponentIdentifier from "../CommonComponent/ComponentHeader/ComponentIdentifier";
import HeaderComponent from "../CommonComponent/ComponentHeader/HeaderComponent";
import SectionLoader from "../CommonComponent/SectionLoader/SectionLoader";
import AddWalletForm from "./AgentSubComponent/AddWalletForm";
import AgentForm from "./AgentSubComponent/AgentForm";
import AgentImport from "./AgentSubComponent/AgentImport";
import AgentTable from "./AgentSubComponent/AgentTable";
import ChangePasswordForm from "./AgentSubComponent/ChangePasswordForm";
import { ToastContainer } from "react-toastify";

export const AgentContext = createContext()

function AgentComponent(props) {
    // Hook
    const dispatch = useDispatch()
    const allAgentTableLoaderRef = useRef()

    //State
    const [allAgentReload, setAllAgentReload] = useState(false)
    const [agentAddModalShow, setAgentAddModalShow] = useState(false)
    const [agentEditModalShow, setAgentEditModalShow] = useState(false)
    const [addWalletModelShow, setAddWalletModelShow] = useState(false)
    const [changePasswordModelShow, setChangePasswordModelShow] = useState(false)
    const [importModalShow, setImportModalShow] = useState(false)

    const [filteredAgentData, setFilteredAgentData] = useState([])
    const [getSingleAgentData, setGetSingleAgentData] = useState({})

    // data getting from store
    const allAgent = useSelector(state => state.agentSlice.allAgent)

    const user_detail = JSON.parse(Auth.header().userdetail)

    // single agent data reset
    useEffect(() => {
        if (agentEditModalShow == false && changePasswordModelShow == false && addWalletModelShow == false) {
            setGetSingleAgentData({})
        }
    }, [agentEditModalShow, changePasswordModelShow, addWalletModelShow])

    // get all  agent lifecycle
    useEffect(() => {
        const Payload = {
            data: { agent_id: user_detail?.is_admin ? null : user_detail?.id },
            allAgentTableLoaderRef,
        }
        dispatch(getAllAgentAction(Payload))
    }, [allAgentReload])


    // export on click
    // const exportOnClick = () => {

    //     // data for export
    //     const dataForExport = []
    //     filteredAgentData.map(singleAgent => {
    //         let extinsibleObj = { ...singleAgent }
    //         // singleAgent.total_member = "ha"ø
    //         extinsibleObj.total_member = singleAgent.members[0]?.total_member || 0
    //         delete extinsibleObj.members
    //         // console.log(singleAgent.members[0]?.total_member || 0)
    //         // console.log(a)
    //         dataForExport.push(extinsibleObj)
    //     })

    //     const headerOrder = [
    //         "avatar",
    //         "id",
    //         "full_name",
    //         "mobile",
    //         "whats_app",
    //         "adhaar_no",
    //         "collection_area_state",
    //         "collection_area_district",
    //         "collection_area_police_station",
    //         "collection_area_post_office",
    //         "collection_area_village",
    //         "collection_area_para",
    //         "collection_area_pincode",
    //         "collection_area_place",
    //         "collection_area_city",
    //         "total_collection",
    //         "user_name",
    //         "balance",
    //         "total_member"
    //     ];


    //     // console.log(dataForExport)
    //     let wb = XLSX.utils.book_new()
    //     let ws = XLSX.utils.json_to_sheet(dataForExport)
    //     // add custom header row at top
    //     XLSX.utils.sheet_add_aoa([headerOrder], { origin: "A1" });
    //     XLSX.utils.book_append_sheet(wb, ws, "allAgent")
    //     XLSX.writeFile(wb, "allAgent.xlsx")
    // }



    const exportOnClick = () => {
        const headerOrder = [
            // "avatar",
            "sl",
            "id",
            "grade",
            "full_name",
            // "adhaar_no",
            "collection_area_village",
            "collection_area_para",
            "collection_area_police_station",
            "collection_area_district",
            "collection_area_state",
            "collection_area_place",
            "collection_area_city",
            "total_member",
            "mobile",
            "whats_app",
            // "balance",
        ];

        const headerLabels = [
            // "Avatar",
            "SL",
            "ID",
            "Grade",
            "Name",
            // "Adhaar No",
            "Village",
            "Neighborhood",
            "Police Station",
            "District",
            "State",
            "Place",
            "City",
            "Donor No.",
            "Mobile",
            "WhatsApp",
            // "Total Member"
        ];

        const dataForExport = filteredAgentData.map((singleAgent, index) => {
            const obj = {};
            headerOrder.forEach((key) => {
                if (key == "sl") {
                    obj[key] = index + 1
                }
                else if (key === "total_member") {
                    obj[key] = singleAgent.members?.[0]?.total_member || 0;
                } else {
                    obj[key] = singleAgent[key] ?? "";
                }
            });
            return obj;
        });

        // Combine header + data
        const finalData = [
            headerLabels, // first row = headers
            ...dataForExport.map(item => headerOrder.map(key => item[key]))
        ];

        // create worksheet with styles
        const ws = XLSX.utils.aoa_to_sheet(finalData);

        // style header row (row 1)
        headerLabels.forEach((_, i) => {
            const cellAddress = XLSX.utils.encode_cell({ r: 0, c: i });
            if (ws[cellAddress]) {
                ws[cellAddress].s = {
                    fill: { fgColor: { rgb: "FFFF00" } }, // yellow background
                    font: { bold: true },
                    alignment: { horizontal: "center", vertical: "center" },
                    border: {
                        top: { style: "thin", color: { rgb: "000000" } },
                        bottom: { style: "thin", color: { rgb: "000000" } },
                        left: { style: "thin", color: { rgb: "000000" } },
                        right: { style: "thin", color: { rgb: "000000" } }
                    }
                };
            }
        });

        // auto width
        const colWidths = headerLabels.map(h => ({ wch: h.length + 5 }));
        ws["!cols"] = colWidths;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "allAgent");
        XLSX.writeFile(wb, "all_collector.xlsx");
    };


    // download excel for add agent
    const downloadExcelForAddAgent = () => {
        let userDetail = JSON.parse(Auth.header().userdetail || "{}")
        let wb = XLSX.utils.book_new()
        let ws = XLSX.utils.json_to_sheet([{
            full_name: "",
            mobile: '',
            whats_app: "",
            adhaar_no: "",
            collection_area_state: "",
            collection_area_district: "",
            collection_area_police_station: "",
            collection_area_post_office: "",
            collection_area_village: "",
            collection_area_para: "",
            collection_area_pincode: "",
            collection_area_place: "",
            collection_area_city: "",
            user_name: "",
            password: "",
            balance: "",
            created_user: userDetail.user_name
        }])
        XLSX.utils.book_append_sheet(wb, ws, "allAgent")
        XLSX.writeFile(wb, "agentImportSheet.xlsx")
    }

    return (
        <>
            <AgentContext.Provider value={{
                agentAddModalShow,
                setAgentAddModalShow,
                setAllAgentReload,
                setAgentEditModalShow,
                getSingleAgentData,
                setGetSingleAgentData,
                setAddWalletModelShow,
                setChangePasswordModelShow,
                setImportModalShow

            }}>
                <Row>

                    <Col lg={12} md={12} sm={12} >
                        <Card>
                            <Card.Header className="d-flex align-items-center justify-content-between">
                                <ComponentIdentifier link_name={user_detail?.is_admin == "1" ? "Collector List" : "Profile Details"} component_name={""} />

                                <div className="d-flex align-items-center justify-content-between">
                                    {HeaderComponent.refresh([setAllAgentReload])}
                                    {user_detail?.is_admin == "1" ? <>{HeaderComponent.add(setAgentAddModalShow)}</> : <></>}

                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="position-relative w-100 d-block">
                                    <Row className="mb-3">
                                        <Col lg={3} md={4} sm={12} className="searchArea">
                                            {/*agent search*/}
                                            <CommonSearch
                                                preFilterData={allAgent}
                                                setFilteredDataState={setFilteredAgentData}
                                                placeHolder={"Name / Village / Phone No./ Police Station"}
                                                propertyForMatch={["full_name", "collection_area_village", "mobile", "collection_area_police_station"]}
                                            />
                                        </Col>
                                        {user_detail?.is_admin == "1" ? <Col lg={9} md={8} sm={12} className="mt-1 btn-area text-lg-end text-center">
                                            {/* <Button
                                                className="me-2 btn-md"
                                                variant="success"
                                                onClick={e => downloadExcelForAddAgent()}
                                            ><AiOutlineDownload /> Download Excel</Button> */}
                                            <Button
                                                className="me-2 mb-2 btn-md"
                                                variant="info"
                                                onClick={e => exportOnClick()}
                                            ><AiOutlineDownload /> Download </Button>
                                            <Button
                                                className="btn-md mb-2"
                                                variant="primary"
                                                onClick={e => setImportModalShow(true)}><GrDocumentUpload /> Upload
                                            </Button>
                                        </Col> : <></>}
                                    </Row>

                                    <AgentTable data={filteredAgentData} />
                                    <SectionLoader loading_handle_ref={allAgentTableLoaderRef} />
                                </div>
                                {/*add modal show*/}
                                <CommonModal
                                    show={agentAddModalShow}
                                    setShow={setAgentAddModalShow}
                                    title={"Add Collector"}
                                    size="lg"

                                >
                                    <AgentForm />
                                </CommonModal>
                                {/*Add Wallet Modal*/}
                                <CommonModal
                                    show={addWalletModelShow}
                                    setShow={setAddWalletModelShow}
                                    title={"Wallet"}
                                >
                                    <AddWalletForm />
                                </CommonModal>
                                {/*edit agent modal*/}
                                <CommonModal
                                    show={agentEditModalShow}
                                    setShow={setAgentEditModalShow}
                                    title={"Edit Collector"}
                                    size="lg"
                                >
                                    <AgentForm formType={'Update'} />
                                </CommonModal>

                                {/*Change Password Modal*/}
                                <CommonModal
                                    show={changePasswordModelShow}
                                    setShow={setChangePasswordModelShow}
                                    title={"Change Password"}
                                >
                                    <ChangePasswordForm />
                                </CommonModal>
                                {/*import modal show*/}
                                <CommonModal
                                    show={importModalShow}
                                    setShow={setImportModalShow}
                                    title={"Import Collector"}
                                    size="md"

                                >
                                    <AgentImport />
                                </CommonModal>
                            </Card.Body>
                        </Card>
                    </Col>

                </Row>
                <ToastContainer />









            </AgentContext.Provider >
        </>
    );
}

export default AgentComponent;